import { ContentLayout } from '@/bundle/Layouts/ContentLayout/ContentLayout';
import { useParams } from 'react-router';
import { getAuditLogPath } from '../path/path';
import { useQuery } from '@tanstack/react-query';
import { AUDIT_LOG_QUERY_KEYS, loadAuditEvent } from '../api/api';
import { PageBody } from '@/components/Page/PageBody/PageBody';
import { PageContent } from '@/components/Page/PageContent/PageContent';
import { AuditEventDetailsWidget } from '../ui/AuditEventDetailsWidget';
import { AuditEventChangedFields } from '../ui/AuditEventChangedFields';
import { AuditLogEventDetailsWrapper } from './styles';
import { DetailsWidget } from '@/components/DetailsWidget/DetailsWidget';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';
import { isEmptyObject } from '@/helpers/objectHelpers';

export const AuditLogEventDetailsPage = () => {
  const { id } = useParams();
  const { navigateBack } = useStatefulNavigation();

  const { data, isPending } = useQuery({
    queryKey: [AUDIT_LOG_QUERY_KEYS.event, id],
    queryFn: () => loadAuditEvent(id),
  });

  const details = data?.body;
  const hasAnyDetails = !isEmptyObject(details?.data);

  return (
    <ContentLayout
      title='Audit Log Event Details'
      backButton='Back to Audit Log'
      breadcrumbs='My Vault > Event Details'
      onBack={() => navigateBack(getAuditLogPath())}
      apiError={data?.error}
    >
      <PageBody>
        <PageContent>
          <AuditLogEventDetailsWrapper>
            {details && <AuditEventDetailsWidget event={details} isLoading={isPending} details={details} />}
            {details && hasAnyDetails && (
              <DetailsWidget>
                <AuditEventChangedFields details={details} />
              </DetailsWidget>
            )}
          </AuditLogEventDetailsWrapper>
        </PageContent>
      </PageBody>
    </ContentLayout>
  );
};
